import React, { useState } from "react";
import EmailSubscriptionsTab from "./EmailSubscriptionsTab";
import MyPreferencesLegacyTab from "./MyPreferencesLegacyTab";

const TAB_STORAGE_KEY = "myPreferencesSelectedTab";

const TAB_LABELS = ["Email Subscriptions", "My Preferences"] as const;

export default function MyPreferencesPage(): React.ReactElement {
  const getInitialTab = (): number => {
    const saved = sessionStorage.getItem(TAB_STORAGE_KEY);
    if (saved != null) {
      const parsed = Number(saved);
      if (parsed === 0 || parsed === 1) {
        return parsed;
      }
    }
    return 0;
  };

  const [selectedTabIndex, setSelectedTabIndex] = useState(getInitialTab);
  const [legacyTabVisited, setLegacyTabVisited] = useState(
    () => getInitialTab() === 1,
  );

  function handleTabClick(index: number): void {
    setSelectedTabIndex(index);
    sessionStorage.setItem(TAB_STORAGE_KEY, String(index));
    if (index === 1) {
      setLegacyTabVisited(true);
    }
  }

  return (
    <div className="w-full px-6 lg:px-10 py-8 lg:py-10 bg-white">
      <h1 className="text-left text-primary font-medium text-xl lg:text-3xl mb-6 font-decimal [transform:scaleY(1.0)] origin-bottom">
        Site Preferences
      </h1>

      <div className="tabs-container gap-1 flex relative z-10 self-stretch overflow-x-scroll mb-6">
        {TAB_LABELS.map((title, index) => (
          <button
            key={title}
            type="button"
            onClick={() => handleTabClick(index)}
            className={`py-3 pl-3 min-h-[2.6125rem] pr-2 flex min-w-[12rem] justify-center items-center gap-3 lg:py-3 lg:px-3 ${
              index === selectedTabIndex
                ? "bg-primary text-white"
                : "bg-[#D3D3D3] text-[#514F4F]"
            }`}
          >
            <span className="font-decimal text-[.75rem] font-medium leading-[1.125rem] md:text-[.875rem] lg:text-base lg:leading-5 uppercase">
              {title}
            </span>
          </button>
        ))}
      </div>

      {/* Keep email tab mounted so unsaved changes survive tab switches */}
      <div style={{ display: selectedTabIndex === 0 ? "block" : "none" }}>
        <EmailSubscriptionsTab />
      </div>
      {legacyTabVisited && (
        <div style={{ display: selectedTabIndex === 1 ? "block" : "none" }}>
          <MyPreferencesLegacyTab />
        </div>
      )}
    </div>
  );
}
